import { I18n } from '@lingui/core';
import { t } from '@lingui/macro';

export const getAlertSuccessTranslation = (successRate: number | null | undefined, i18n: I18n) => {
  const color =
    successRate == null
      ? 'info'
      : successRate === 1
      ? 'success'
      : successRate === 0
      ? 'error'
      : successRate === -1
      ? 'info'
      : 'warning';
  const label =
    successRate == null
      ? t(i18n)`Sin envíos`
      : successRate === 1
      ? t(i18n)`Exitoso`
      : successRate === 0
      ? t(i18n)`Fallido`
      : successRate === -1
      ? t(i18n)`Sin notificaciones configuradas`
      : t(i18n)`Parcialmente exitoso`;

  return {
    color,
    label,
  } as const;
};
